import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
import { getStorage, connectStorageEmulator } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDy_R9N4LRpgTN8Da--49O2VD2R-_shiUQ",
  authDomain: "simplytelehealth.firebaseapp.com",
  databaseURL: "https://simplytelehealth-default-rtdb.firebaseio.com",
  projectId: "simplytelehealth",
  storageBucket: "simplytelehealth.firebasestorage.app",
  messagingSenderId: "609770255900",
  appId: "1:609770255900:web:02175d71201fa25943d1d9",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);

// Connect to emulators in local development
if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectDatabaseEmulator(database, '127.0.0.1', 9000);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
}
